<template>
  <b-modal id="modal-limit" header-class="warning">
    <template #modal-header>
      <div class="d-inline-flex justify-content-between w-100">
        <div class=""> 
          <h5> {{$t('engine.filemanager.folder.storageLimit.lblTitle', languageEngine)}} </h5>
        </div>
        <div class="d-flex">
          <div class="mr-gd-1">
            <i class="fal fa-question-circle"></i>
          </div>
          <div
            @click="closeModal()"
            id="close-modal-limit"
            class="close-modal cursor-pointer"
          >
            <i class="fal fa-times"></i>
          </div>
        </div>
      </div>
    </template>
    <template>
      <div>
          {{$t('engine.filemanager.folder.storageLimit.lblDetail', languageEngine, {space:space})}}
      </div>
    </template>
    <template #modal-footer>
      <b-button variant="blue" @click="confirm"> {{$t('engine.filemanager.folder.storageLimit.btnUpgrade', languageEngine)}}</b-button>
      <b-button variant="light" @click="closeModal" class="mr-3"> <i class="far fa-times"></i> {{$t('engine.common.btnCancel', languageEngine)}}</b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    })
  },
  methods: {
    closeModal() {
      this.$emit('clear');
      this.$bvModal.hide("modal-limit");
    },
    confirm() {
      this.$emit('upgrade');
      this.$bvModal.hide("modal-limit");
    }
  },
  props:['space']
}
</script>